var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPossuiAnimais = function SvgPossuiAnimais(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4979 9.54801C13.6361 9.66336 13.7617 9.79433 13.8723 9.93851L18.4745 15.9376C19.3018 17.0159 19.1341 18.5894 18.1001 19.4521C17.6749 19.8068 17.1467 20 16.6022 20H7.3978C6.07355 20 5.00004 18.8805 5.00004 17.4996C5.00004 16.9318 5.18534 16.3809 5.52546 15.9376L10.1277 9.93851C10.9549 8.86018 12.4638 8.68534 13.4979 9.54801ZM19.5 8C20.8807 8 22 9.11929 22 10.5C22 11.8807 20.8807 13 19.5 13C18.1193 13 17 11.8807 17 10.5C17 9.11929 18.1193 8 19.5 8ZM4.5 8C5.88071 8 7 9.11929 7 10.5C7 11.8807 5.88071 13 4.5 13C3.11929 13 2 11.8807 2 10.5C2 9.11929 3.11929 8 4.5 8ZM15.5 3C16.8807 3 18 4.11929 18 5.5C18 6.88071 16.8807 8 15.5 8C14.1193 8 13 6.88071 13 5.5C13 4.11929 14.1193 3 15.5 3ZM8.5 3C9.88071 3 11 4.11929 11 5.5C11 6.88071 9.88071 8 8.5 8C7.11929 8 6 6.88071 6 5.5C6 4.11929 7.11929 3 8.5 3Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPossuiAnimais, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/possui-animais.15a884eb.svg";
export { ForwardRef as ReactComponent };